// extracted by mini-css-extract-plugin
export var logo = "_lk-2";
export var logoWrapper = "_lk-1";
export var strip = "_lk-0";